import { render, staticRenderFns } from "./DeleteMovie.vue?vue&type=template&id=167b4be0&scoped=true"
import script from "./DeleteMovie.vue?vue&type=script&lang=js"
export * from "./DeleteMovie.vue?vue&type=script&lang=js"
import style0 from "./DeleteMovie.vue?vue&type=style&index=0&id=167b4be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167b4be0",
  null
  
)

export default component.exports